var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7756 0.0178223C13.3533 0.0178223 14.1914 5.86133 14.1914 5.86133L14.2063 11.9154H27.0149V13.733H9.11893C9.11893 13.733 0.530029 12.7551 0.530029 26.3511C0.530029 39.9476 8.02663 39.4654 8.02663 39.4654H12.5006V33.1561C12.5006 33.1561 12.2594 25.6301 19.8775 25.6301H32.5814C32.5814 25.6301 39.7188 25.7459 39.7188 18.705V7.06329C39.7188 7.06329 40.8028 0.0178223 26.7756 0.0178223ZM19.7129 4.08905C20.0156 4.08878 20.3154 4.14843 20.595 4.26458C20.8747 4.38074 21.1289 4.55113 21.3429 4.76599C21.5569 4.98085 21.7266 5.23598 21.8423 5.51676C21.958 5.79755 22.0175 6.09848 22.0172 6.40235C22.0175 6.70621 21.958 7.00714 21.8423 7.28793C21.7266 7.56871 21.5569 7.82384 21.3429 8.0387C21.1289 8.25356 20.8747 8.42395 20.595 8.54011C20.3154 8.65626 20.0156 8.71591 19.7129 8.71564C19.4102 8.71591 19.1105 8.65626 18.8308 8.54011C18.5511 8.42395 18.297 8.25356 18.083 8.0387C17.8689 7.82384 17.6992 7.56871 17.5835 7.28793C17.4678 7.00714 17.4084 6.70621 17.4087 6.40235C17.4084 6.09848 17.4678 5.79755 17.5835 5.51676C17.6992 5.23598 17.8689 4.98085 18.083 4.76599C18.297 4.55113 18.5511 4.38074 18.8308 4.26458C19.1105 4.14843 19.4102 4.08878 19.7129 4.08905Z",
    fill: "url(#paint0_linear_24_2942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1567 52.8213C40.579 52.8213 39.7409 46.9778 39.7409 46.9778L39.726 40.9239H26.9172V39.1063H44.8132C44.8132 39.1063 53.4021 40.0842 53.4021 26.4878C53.4021 12.8915 45.9055 13.3737 45.9055 13.3737H41.4315V19.6828C41.4315 19.6828 41.6727 27.2088 34.0546 27.2088H21.3507C21.3507 27.2088 14.2133 27.093 14.2133 34.1341V45.776C14.2133 45.776 13.1295 52.8213 27.1565 52.8213H27.1567ZM34.2194 48.7505C33.9167 48.7507 33.6169 48.6911 33.3373 48.5749C33.0576 48.4588 32.8034 48.2884 32.5894 48.0735C32.3754 47.8587 32.2057 47.6035 32.09 47.3227C31.9743 47.042 31.9148 46.741 31.9151 46.4372C31.9148 46.1333 31.9742 45.8323 32.0899 45.5515C32.2056 45.2707 32.3753 45.0156 32.5893 44.8007C32.8034 44.5858 33.0575 44.4154 33.3372 44.2992C33.6169 44.183 33.9167 44.1234 34.2194 44.1237C34.5221 44.1234 34.8218 44.183 35.1015 44.2992C35.3812 44.4153 35.6353 44.5857 35.8493 44.8006C36.0634 45.0155 36.2331 45.2706 36.3488 45.5514C36.4645 45.8322 36.5239 46.1331 36.5236 46.437C36.5239 46.7408 36.4645 47.0417 36.3488 47.3225C36.2331 47.6033 36.0634 47.8584 35.8493 48.0733C35.6353 48.2882 35.3812 48.4586 35.1015 48.5747C34.8218 48.6909 34.5221 48.7505 34.2194 48.7502V48.7505Z",
    fill: "url(#paint1_linear_24_2942)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_2942",
    x1: 5.61102,
    y1: 4.76717,
    x2: 31.9143,
    y2: 30.7063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_2942",
    x1: 21.6936,
    y1: 21.4899,
    x2: 49.9353,
    y2: 48.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0.5 0.00292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory2);
export default __webpack_public_path__ + "static/media/category-2.358bb6c0a3b07e3c0fe20193680f686c.svg";
export { ForwardRef as ReactComponent };